import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { GetShowQuery } from "@/codegen/graphql/generated/graphql";

interface CurrentEpisodeStoreState {
  currentEpisode: GetShowQuery["show"]["episodes"][number] | undefined;
  currentShow: GetShowQuery["show"] | undefined;
}
interface CurrentEpisodeStore extends CurrentEpisodeStoreState {
  setCurrentEpisode: (
    episode: GetShowQuery["show"]["episodes"][number] | undefined,
  ) => void;
  setCurrentShow: (show: GetShowQuery["show"] | undefined) => void;
}

export const useCurrentEpisodeStore = create<CurrentEpisodeStore>()(
  devtools((set, _get) => ({
    currentEpisode: undefined,
    currentShow: undefined,

    setCurrentEpisode: (episode) => set({ currentEpisode: episode }),
    setCurrentShow: (show) => set({ currentShow: show }),
  })),
);

export const useSetCurrentEpisode = () =>
  useCurrentEpisodeStore((state) => state.setCurrentEpisode);

export const useCurrentEpisode = () =>
  useCurrentEpisodeStore((state) => state.currentEpisode);

export const useCurrentShow = () =>
  useCurrentEpisodeStore((state) => state.currentShow);

export const useSetCurrentShow = () =>
  useCurrentEpisodeStore((state) => state.setCurrentShow);
